export default "__VITE_ASSET__BY5WtYYd__"